var map = {
	"./975_105_1_Downtown00001.jpg": "483d",
	"./Ad_1__Shipbuilding.jpg": "80cb",
	"./Document_1__Shipbuilding_986_33_1.jpg": "715e",
	"./Image_1__First_Canal_985_5_208_inside.jpg": "8323",
	"./Image_1__First_Canal_985_5_208_inside_preview.jpg": "b814",
	"./Image_1__Second_Canal_996_10_2_entrance_to_Welland_Canal___Port_Colborne.jpg": "7e60",
	"./Image_1__Third_Canal_990_35_2.jpg": "9a74",
	"./Image_2__First_Canal_L_1_45_976_Linking_the_Great_Lakes.jpg": "6363",
	"./Image_2__Second_Canal_996_10_3_Lock_no_23_Thorold.jpg": "4443",
	"./Image_2__Third_Canal_990_35_1.jpg": "014e",
	"./Map_1__Realignment.jpg": "b341",
	"./Map_1__Third_Canal.jpg": "ad2d",
	"./Map_2__First_Canal.jpg": "a49a",
	"./Map_3__First_Canal.jpg": "d3d8",
	"./Map_4__First_Canal_Welland_Canal_1837_NMC_21589.jpg": "bcd9",
	"./Map_5__First_CanalNMC_29139_Niagara_and_First_Welland_Canal.jpg": "874f",
	"./Phorto_1__People_&_Pleasures_984_102_1_Fortier_Family.jpg": "2774",
	"./Phorto_1__People__Pleasures_984_102_1_Fortier_Family.jpg": "4fed",
	"./Phorto_1__People_and_Pleasures_984_102_1_Fortier_Family.jpg": "9b54",
	"./Phot_3__Second_Canal_986_82_239.jpg": "2ba9",
	"./Photo 7- Third Canal 992_17_4.jpg": "247f",
	"./Photo_10___Construction_2017_36_1.jpg": "b66a",
	"./Photo_1_First_Canal.jpg": "7618",
	"./Photo_1_First_Canal.png": "33cf",
	"./Photo_1_Planing_Mill_Reichman_Planinig_Mill_979_58_45.jpg": "036d",
	"./Photo_1__Construction_986_82_244.jpg": "0d7c",
	"./Photo_1__East_Street_980_84_Hotel00001.jpg": "3d1d",
	"./Photo_1__Fourth_Canal_992_36_12.jpg": "803a",
	"./Photo_1__Grain_Industry_2007_5_43.jpg": "25dc",
	"./Photo_1__Second_Canal_986_82_173.jpg": "5ea3",
	"./Photo_1__Ship_Building_976_280_5.jpg": "8a29",
	"./Photo_1__Third_Canal_993_13_1.jpg": "bba4",
	"./Photo_1__West_Street__975_105_2.jpg": "6fb7",
	"./Photo_2__Construction_986_82_245.jpg": "527b",
	"./Photo_2__Grain_Industry_977_454_2.jpg": "073e",
	"./Photo_2__Second_Canal_988_11_3.jpg": "ca50",
	"./Photo_2__Shipbuilding_976_280_3.jpg": "4690",
	"./Photo_2__Third_Canal_976_280_2.jpg": "ba99",
	"./Photo_2__West_Street_2010_3_434.jpg": "b235",
	"./Photo_2___Fourth_Canal_978_36_18.jpg": "c1fd",
	"./Photo_2___People_&_Pleasures_982_87_2_Boys_on_Canal.jpg": "c416",
	"./Photo_2___People__Pleasures_982_87_2_Boys_on_Canal.jpg": "35c0",
	"./Photo_2___People_and_Pleasures_982_87_2_Boys_on_Canal.jpg": "3668",
	"./Photo_3__East_Street__976_243_3.jpg": "1797",
	"./Photo_3__Third_Canal_988_8_14.jpg": "b310",
	"./Photo_3___Construction_983_2_1.jpg": "a22f",
	"./Photo_3___Fourth_Canal_2006_31_2.jpg": "f36e",
	"./Photo_3___People_&_Pleasures_983_91_155_Pier_&_East_Light.jpg": "554b",
	"./Photo_3___People__Pleasures_983_91_155_Pier_and_East_Light.jpg": "5dce",
	"./Photo_3___People_and_Pleasures_983_91_155_Pier_and_East_Light.jpg": "6833",
	"./Photo_4__Fourth_Canal_979_79_1.jpg": "8b87",
	"./Photo_4__Second_Welland_Canal_986_82_240.jpg": "0d72",
	"./Photo_4__Welland_Canal_2009_20_207_Winter_Lay_Up_PC.jpg": "adb5",
	"./Photo_4___Construction_2009_20_212_Canal_Construction_PC_West_St_in_background.jpg": "d5b0",
	"./Photo_4___People_&_Pleasures_Boat_excursion_2009_20_81.jpg": "6e4c",
	"./Photo_4___People__Pleasures_Boat_excursion_2009_20_81.jpg": "3c62",
	"./Photo_4___People_and_Pleasures_Boat_excursion_2009_20_81.jpg": "d24b",
	"./Photo_5__Construction_985_98_2.jpg": "5932",
	"./Photo_5__Fourth_Canal_990_25_1.jpg": "f9bd",
	"./Photo_5__People_&_Pleasures_993_22_2.jpg": "136f",
	"./Photo_5__People__Pleasures_993_22_2.jpg": "4460",
	"./Photo_5__People_and_Pleasures_993_22_2.jpg": "d80e",
	"./Photo_5__Second_Canal_986_82_246.jpg": "3d72",
	"./Photo_5__Third_Canal_2007_5_42.jpg": "62eb",
	"./Photo_6__Third_Canal976_262_3.jpg": "b25b",
	"./Photo_6___Construction_992_36_4.jpg": "d910",
	"./Photo_6___Fourth_Canal_Ship_docked_West_St_976_281_2.jpg": "afde",
	"./Photo_7__Construction_Welland_Canal_993_13_17.jpg": "5b86",
	"./Photo_7__Third_Canal_992_17_4.jpg": "30f6",
	"./Photo_7___Third_Canal_2007_5_45.jpg": "7209",
	"./Photo_8__Construction_985_109_49.jpg": "c0ee",
	"./Photo_9___Construction_986_63_3.jpg": "0a28",
	"./Pritchard_map_2.jpg": "806f",
	"./Report_1__First_Canal_Randall_recommends_Gravelly_Bay_1831.jpg": "7bcc",
	"./winter_layup.jpg": "b81f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";